Question assignment smartmap (PDF)